export class MetaElementBehaviorPropertyDef {
  public static readonly DISPLAY_NAME: string = 'displayName';
  public static readonly DELTA_U: string = 'deltaU';
  public static readonly DELTA_V: string = 'deltaV';
  public static readonly DELTA_N: string = 'deltaN';
  public static readonly ROTATION_ANGLES: string = 'rotationAngles';
  public static readonly SWITCH_ANGLE: string = 'switchAngle';
  public static readonly DYNAMIC_PIN_REFERENCE: string = 'dynamicPinReference';
  public static readonly RANGE_ON_LINE_TYPE: string = 'rangeOnLineType';
  public static readonly TEXT_CHECK_CLASS: string = 'textCheckClass';
  public static readonly ALLOW_MERGE: string = 'allowMerge';
  public static readonly ALLOWED_MULTILINES: string = 'maxAllowedMultilines';
  public static readonly IS_STATIC_CONNECTION: string = 'isStaticConnection';
  public static readonly SELECTION_SET_ID: string = 'selectionSetId';
  public static readonly CONNECTION_SET_ID: string = 'connectionSetId';
  public static readonly MULTIPURPOSE_CONNECTION_SET_ID: string = 'multipurposeConnectionSetId';
  public static readonly CONNECTED_ARTICLE_IS_NOT_DELETABLE: string = 'connectedArticleIsNotDeletable';

  public static readonly DEFAULT_TEXT: string = 'defaultText';
  public static readonly DEFAULT_TEXT_ROTATION: string = 'defaultTextRotation';
  public static readonly DEFAULT_TEXT_VERTICAL_ALIGNMENT: string = 'defaultTextVerticalAlignment';
  public static readonly PLUG_CONNECTION_POSITION: string = 'plugConnectionPosition';

  public static readonly CONNECTION_IS_NOT_SELECTABLE: string = 'isNotSelectable';

  public static readonly MARKER_CARD_NR: string = 'markerCardElementNr';

  public static readonly LEVEL_NUMBER: string = 'levelNr';
  public static readonly CALCULATED_LEVEL_NUMBER: string = 'calculatedLevelNr';

  public static readonly LABEL_CELL_WIDTH: string = 'labelCellWidth';
  public static readonly IS_NOT_PART_OF_DEFAULT_LABELING: string = 'isNotPartOfDefaultLabeling';

  public static readonly POSITION: string = 'position';
  public static readonly DELTA_DISTANCE: string = 'deltaDistance';

  public static readonly IS_MERGE_FOR_AREA_DENIED: string = 'isMergeForAreaDenied';

  public static readonly ACCESSORY_CATEGORY: string = 'accessoryCategory';

  public static readonly IS_N_POTENTIAL_JUMPER_CONNECTION: string = 'isNPotentialJumperConnection';
  public static readonly IS_PE_JUMPER_CONNECTION: string = 'isPEJumperConnection';

  public static readonly IS_DYEABLE: string = 'isDyeable';

  public static readonly DEFAULT_FONT_COLOR_HEX: string = 'defaultFontColorHex';
}
